import styled from 'styled-components'

export const ButtonContainer = styled.button<{ isCollapsed: boolean }>`
  position: relative;
  padding: 12px 0;
  margin: ${({ isCollapsed }) => (isCollapsed ? '1rem 0.3rem 0' : '1rem 0.5rem 0')};

  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ isCollapsed }) => (isCollapsed ? '0px' : '5px')};

  border: 1px solid ${props => props.theme.colors.color378ff7};
  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: ${({ theme }) => theme.zds.border.radius100};
  cursor: pointer;

  span {
    color: ${props => props.theme.colors.color378ff7};
    font-size: ${({ isCollapsed }) => (isCollapsed ? '0' : '0.75rem')};
    font-weight: 400;
    white-space: nowrap;
  }
`
